import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Reusable component for a dropdown item
const DropdownItem = ({ text, navLink }) => {

    const location = useLocation();
    const isActive = location.pathname === navLink;

    return(
    <Link className={`dropdown-item ${isActive ? 'active' : ''}`} to={navLink}>
        {text}
    </Link>)
};

// Reusable component for a dropdown header
const DropdownHeader = ({ text }) => (
    <h6 className="dropdown-header">{text}</h6>
);

const EntriesLink = () => {

    return (
        <li className="btn-group nav-item">
            <Link to='#' className="nav-link" data-toggle="dropdown" aria-expanded="false">
                {/* <span className="badge badge-pill badge-danger ml-0 mr-2">4</span> */}
                <i className="nav-link-icon fa fa-book"></i>
                 Entries
                <i className="fa fa-angle-down ml-2 opacity-5"></i>
            </Link>
            <div role="menu" className="rm-pointers dropdown-menu">
                <div className="scroll-area-xs-none">
                    <div className="scrollbar-container">
                        <DropdownHeader text="Enter New" />
                        <DropdownItem text="Income" navLink= "/income-new" />
                        <DropdownItem text="Expense" navLink="/expenses-new" />
                        <DropdownItem text="Supplier Invoice" navLink="/expenses-new-invoice" />
                        <DropdownItem text="Contra Asset" navLink="/asset-contra-new" />
                        <DropdownItem text="Journal Entry" navLink="/transaction-journal-new" />
                        
                        <div className="dropdown-divider"></div>
                        <DropdownHeader text="Reports" />
                        <DropdownItem text="Ledger Entries" navLink="/transaction-ledger" />
                        <DropdownItem text="Journal Entries" navLink="/transaction-journal" />
                        <DropdownItem text="Supplier Invoices" navLink="/expenses-invoicing" />

                    </div>
                </div>
            </div>
        </li>
    );
};

export default EntriesLink;
